import { render, staticRenderFns } from "./CopySPUModal.vue?vue&type=template&id=018b40de&scoped=true"
import script from "./CopySPUModal.vue?vue&type=script&lang=ts"
export * from "./CopySPUModal.vue?vue&type=script&lang=ts"
import style0 from "./CopySPUModal.vue?vue&type=style&index=0&id=018b40de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018b40de",
  null
  
)

export default component.exports